'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/router';
import Script from 'next/script';
import { useConsent } from '../contexts/ConsentContext';

const GA_MEASUREMENT_ID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID;
const GOOGLE_ADS_ID = 'AW-664154700';

/**
 * Loads GA4 + Google Ads when user has accepted analytics cookies.
 * Tracks SPA route changes so Google Ads receives page-view conversions.
 */
export function GoogleAnalytics() {
  const { consent, mounted } = useConsent();
  const router = useRouter();

  const shouldLoad = GA_MEASUREMENT_ID && mounted && consent !== false;

  // Track SPA route changes for both GA4 and Google Ads
  useEffect(() => {
    if (!shouldLoad) return;

    const handleRouteChange = (url) => {
      if (typeof window.gtag !== 'function') return;
      window.gtag('config', GA_MEASUREMENT_ID, { page_path: url });
      window.gtag('config', GOOGLE_ADS_ID, { page_path: url });
    };

    router.events.on('routeChangeComplete', handleRouteChange);
    return () => router.events.off('routeChangeComplete', handleRouteChange);
  }, [shouldLoad, router.events]);

  if (!shouldLoad) return null;

  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`}
        strategy="afterInteractive"
      />
      <Script id="ga-config" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${GA_MEASUREMENT_ID}');
          gtag('config', '${GOOGLE_ADS_ID}');
        `}
      </Script>
    </>
  );
}
